import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
export const listAWSGateways = async ({ getStatistics }) => {
    const path = `/gateway`;
    const params = { getStatistics };
    debug && console.log('INFO: getDeviceMessages posting', { path, params });
    const res = { err: null, data: null };
    const queryRes = (await ApiGateway.post(path, params, 'DeviceControlApi'));
    if (queryRes.err) {
        res.err = queryRes.err;
    }
    if (queryRes.data) {
        debug && console.log('Device message data', queryRes);
        res.data = queryRes.data;
    }
    return res;
};
